import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-bookseller-districtwise-statement-component',
  templateUrl: './bookseller-districtwise-statement-component.component.html',
  styleUrls: ['./bookseller-districtwise-statement-component.component.scss']
})
export class BooksellerDistrictwiseStatementComponentComponent implements OnInit {

  // ===== HEADER =====
  state: string = '';
  district: string = '';
  updateStatus: boolean = false;

  dispatchdate: any = '';
  dispatchankDate: string = '';
  sundayankDate: string = '';

  book_name: any = '';

  // ===== TABLE DATA =====
  filtereddistrictwisesubcout: any[] = [];

  // ===== TOTALS =====
  total_sub_count: number = 0;
  totalparcel: number = 0;

  // ===== LOADER =====
  isLoading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<BooksellerDistrictwiseStatementComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
ngOnInit(): void {

  console.log('Dialog Data =>', this.data);

  this.state = this.data.state || '';
  this.district = this.data.district || '';
  this.updateStatus = this.data.updateStatus || false;

  this.dispatchdate = this.data.dispatchdate || '';

  console.log('Dispatch Date =>', this.dispatchdate);

  this.dispatchankDate = this.formatDate(this.dispatchdate);

  this.book_name = Array.isArray(this.data.book_name)
    ? this.data.book_name.join(', ')
    : (this.data.book_name || '');

  this.getBooksellerDistrictwiseStatement();
}

  // ================= FORMAT DATE =================
  formatDate(dateValue: any): string {

    if (!dateValue) return '';

    // already formatted dd/MM/yyyy
    if (typeof dateValue === 'string' && dateValue.includes('/')) {
      return dateValue;
    }

    const d = new Date(dateValue);

    if (isNaN(d.getTime())) return '';

    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  }

  // ================= API CALL =================
  getBooksellerDistrictwiseStatement(): void {

    this.isLoading = true;

    const request = {
      state: this.data?.state || '',
      district: this.data?.district || '',
      start_date: this.data?.start_date || '',
      end_date: this.data?.end_date || '',
      book_name: this.data?.book_name || [],
      delivery_mode: this.data?.delivery_mode || [],
      distribution_mode: this.data?.distribution_mode || [],
      sub_distribution_mode: this.data?.sub_distribution_mode || []
    };

    console.log('REQUEST =>', request);

    this.service
      .getDistributionRepresentativeSBhetHastewise1(request)
      .subscribe({

        next: (response: any) => {

          this.isLoading = false;

          if (response?.status && Array.isArray(response?.data)) {

            this.filtereddistrictwisesubcout = response.data.map((item: any) => ({
              district: item?.district || '-',
              total_booksellers: Number(item?.total_booksellers || 0),
              total_book_copies: Number(item?.total_book_copies || 0)
            }));

            this.calculateTotals();

          } else {
            this.filtereddistrictwisesubcout = [];
            this.resetTotals();
          }
        },

        error: (err: any) => {
          console.error('API ERROR =>', err);
          this.isLoading = false;
          this.resetTotals();
        }

      });
  }

  // ================= TOTALS =================
  calculateTotals(): void {

    this.total_sub_count = this.filtereddistrictwisesubcout
      .reduce((sum, i) => sum + (Number(i.total_booksellers) || 0), 0);

    this.totalparcel = this.filtereddistrictwisesubcout
      .reduce((sum, i) => sum + (Number(i.total_book_copies) || 0), 0);
  }

  resetTotals(): void {
    this.total_sub_count = 0;
    this.totalparcel = 0;
  }

  // ================= EXPORT =================
  exportExcel(fileName: string): void {

    let csvContent = '\uFEFF';

    csvContent += 'विवेक पुस्तक प्रकाशन\n';
    csvContent += `पुस्तकाचे नाव - ${this.book_name}\n`;
    csvContent += `वितरण दि. - ${this.dispatchankDate}\n\n`;

    csvContent += 'जिल्हा,वर्गणीदार संख्या,प्रति संख्या\n';

    this.filtereddistrictwisesubcout.forEach((item: any) => {
      csvContent +=
        `"${item.district}",` +
        `"${item.total_booksellers}",` +
        `"${item.total_book_copies}"\n`;
    });

    csvContent += `"एकूण","${this.total_sub_count}","${this.totalparcel}"\n`;

    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}_${new Date().toISOString().split('T')[0]}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  // ================= SAVE =================
  saveSubscriptionBarcodesDataEntry(): void {

    const payload = this.filtereddistrictwisesubcout.map(item => ({
      issue_date: this.dispatchdate,
      country: this.data?.country || '',
      state: this.state,
      district: item.district,
      number_of_subscribers: item.total_booksellers,
      total: item.total_book_copies,
      added_by: 1,
      delivery_mode: this.data?.delivery_mode || [],
      distribution_mode: this.data?.distribution_mode || [],
      sub_distribution_mode: this.data?.sub_distribution_mode || [],
      book_name: this.data?.book_name || []
    }));

    console.log('SAVE PAYLOAD =>', payload);

    this.service
      .saveIssueSellerDistrictwiseStatementDataEntry1(payload)
      .subscribe({

        next: (res: any) => {
          console.log('SAVE RESPONSE =>', res);
          alert('Saved Successfully');
        },

        error: (err: any) => {
          console.error('SAVE ERROR =>', err);
          alert('Save Failed');
        }

      });
  }

  // ================= CLOSE =================
  close(): void {
    this.dialogRef.close();
  }
}